<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="250px">

    <!-- 第二步 -->
    <div>
        <el-form-item class="personList" label="著作权人" prop="right">
        <span v-for="(author, index) in form.right" :key="index"
            >{{
            author.obligeeType == "1"
                ? author.userName
                : author.companyName
            }}&nbsp;</span
        >
        <el-button type="text" @click="isRightDialogVisible = true"
            >选择著作权人</el-button
        >
        <choose-person-dialog
            title="选择著作权人"
            v-if="isRightDialogVisible"
            v-model="form.right"
            :listOpt="obligees"
            :linkObj="{ label: '添加著作权人', path: '/Mine/Obligee' }"
            @close="onSetRightDialogClose"
            @input="onChooseRight"
        ></choose-person-dialog>
        </el-form-item>
        <el-form-item class="submitRow">
        <el-button type="primary" @click="prev">上一步</el-button>
        <el-button type="primary" @click="next">下一步</el-button>
        </el-form-item>
    </div>
    </el-form>
  </div>
</template>

<script>
import { queryExistOrderItems } from "@/api/EvidenceService";
import { queryObligeeList } from "@/api/ObligeeService";
import Steps from "../../../components/Steps";
import multipleSelect from "../../../../../components/form/multipleSelect";
import choosePersonDialog from "../../../../../components/form/choosePersonDialog";
import resultView from "../components/resultView";
import ChinaAreaData from "@/components/common/ChinaAreaData";
import { mapGetters } from "vuex";
import { mixinsScrollErrorPosition } from "../../../../../mixins";
import constants from "@/utils/constants";

export default {
  name: "RegisterInputForm",
  mixins: [mixinsScrollErrorPosition],
  components: {
    Steps,
    multipleSelect,
    choosePersonDialog,
    resultView,
    ChinaAreaData,
  },
  props: {
    stepForm: Object,
  },
  data() {
    return {
      constants,
      form: {
        right: [],
      },
      rules: {
        right: [
          { required: true, message: "请选择著作权人", trigger: "blur" },
        ],
      },
      isAuthorDialogVisible: false,
      isRightDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo"]),
  },
  created() {
    this.loadData();
    this.form = this.stepForm
  },
  methods: {
    loadData() {
    //   queryExistOrderItems().then(({ data }) => {
    //     this.fileList = data;
    //   });
      queryObligeeList(1, 100).then(({ data }) => {
        // console.log("queryObligeeList",data);
        this.obligees = data.list;
      });
    },
    calAmount() {
      let amount = 0;
      let registerConfig = this.evidencePaymentPrice.register;
      amount = registerConfig.amount * 1;

      this.form.orderAmount = amount;
    },
    async onSubmit() {
      console.log("onSubmit..");
      try {
        const formBaseResult = await this.$refs["form"].validate();
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error);
        this.mixinsScrollView();
        return;
      }
      this.setTabIdx("tab2");
    },
    setTabIdx(tabIdx) {
      this.tabIdx = tabIdx;
    },
    onSetAuthorDialogClose() {
      this.isAuthorDialogVisible = false;
    },
    onSetRightDialogClose() {
      this.isRightDialogVisible = false;
    },
    onChooseAuthor(users) {
      this.form.author = users;
    },
    onChooseRight(users) {
      this.form.right = users;
    },
    valiCity(rule, value, callback) {
      if (!this.form.province) {
        callback(new Error("请选择省份"));
        return;
      }
      if (!this.form.city) {
        callback(new Error("请选择城市"));
        return;
      }
      if (!this.form.area) {
        callback(new Error("请选择区县"));
        return;
      }
      callback();
    },
    selectArea(data) {
      this.form.province = data.selectData.province.name;
      this.form.city = data.selectData.city.name;
      this.form.area = data.selectData.area.name;
    },
    selectArea2(data) {
      this.form.province2 = data.selectData.province.name;
      this.form.city2 = data.selectData.city.name;
      this.form.area2 = data.selectData.area.name;
    },
    chooseFile() {
      let files = [];
      for (let i = 0; i < this.form.evidenceFile.length; i++) {
        const element = this.form.evidenceFile[i];
        files.push(this.fileList[element * 1]);
      }
      this.form.files = files;
      this.calAmount();
    },

    chooseSignatureType() {},

        prev(){
            this.$emit('getnext',1)
        },
        async next(){
            try {
              const formBaseResult = await this.$refs["form"].validate();
            } catch (error) {
              // 有错误,定位到错误
              // eslint-disable-next-line
              console.error(error);
              this.mixinsScrollView();
              return;
            }
            this.$emit('getnext',3,this.form)
        },

  },
};
</script>

<style lang='scss' scoped>
@import "../../../../../assets/css/inputForm.scss";
.commonWhiteBg {
  min-height: 800px;
  /deep/ .ant-popover-arrow {
    left: 30%;
  }
}
.ownershipRow {
  margin-bottom: 0;
}
.ownershipWrap {
  position: relative;
  padding-top: 40px;
  /deep/ .el-radio-group {
    position: absolute;
    width: 200%;
    left: 0;
    top: 11px;
  }
  .tips {
    margin-top: 0;
    .red {
      color: #ff4d4f;
      vertical-align: middle;
    }
  }
}
// .tips {
//   margin-top: 20px;
// }
.tips {
  // position: initial;
  position: absolute;
    width: 384px;
    right: -410px;
    top: 0;
}
.signatureName {
  .el-select,
  .el-input {
    width: calc(110% / 2.4);
  }
  .el-select {
    margin-right: calc(20% / 2.4);
  }
}
.Uploader2 {
  font-size: 14px;
  height: 100%;
  text-align: center;
  background: #f9fafc;
  border-radius: 4px;
  border: 1px solid #c0ccda;
}
/deep/ .submitRow .el-form-item__content {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.MainStepsForm .submitRow button {
  width: 46% !important;
}

.stepTitle{
  width: 100%;
  margin: 50px 0 100px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.stepTitle li {
  padding: 0 10px;
}
.stepTitle li span{
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  text-align: center;
  border: 1px solid rgba(0, 18, 22, 0.2);
  font-size: 16px;
  color: rgba(0, 18, 22, 0.2);

}
.stepTitle li p{
  color: rgba(0, 18, 22, 0.45);
  display: inline-block;
  margin-left: 10px;
  font-size: 16px;
}
.stepTitle li.active span{
  border-color: #007DFF;
  color: #fff;
  background: #007DFF;
}
.stepTitle li.active p{
  color: #007DFF;
}
</style>
